import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstance from '../../helpers/axios';
import PaginationTable from '../status/PaginationTable';
import Datetime from 'react-datetime';
import calender from '../../assets/images/calender.png';
import edit from '../../assets/images/edit2.png';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as moment from 'moment';
import DownloadIcon from '@mui/icons-material/Download';
import axios from 'axios';
export const SettlementStatus = {
  PROCESSED: 1,
  VERIFIED: 2,
};

export const ServiceProvider = {
  RAZORPAY: 1,
  DIGIO: 2,
};

const getStatusLabel = (status) => {
  switch (Number(status)) {
    case SettlementStatus.PROCESSED: return 'Processed';
    case SettlementStatus.VERIFIED: return 'Verified';
    default: return '-';
  }
};

const getServiceLabel = (service) => {
  switch (Number(service)) {
    case ServiceProvider.RAZORPAY: return 'Razorpay';
    case ServiceProvider.DIGIO: return 'Digio';
    default: return '-';
  }
};

const StatusBadge = ({ status }) => {
  const label = getStatusLabel(status);
  const styles = {
    Processed: { backgroundColor: '#FFF6E8', color: '#F8A31F' },
    Verified: { backgroundColor: '#ECFDF5', color: '#027A48' },
  };
  const style = styles[label] || { backgroundColor: '#F3F4F6', color: '#667085' };
  return (
    <span style={{
      padding: '4px 12px',
      borderRadius: '16px',
      fontWeight: '600',
      fontSize: '13px',
      fontFamily: 'Inter-Medium',
      display: 'inline-block',
      ...style,
    }}>
      {label}
    </span>
  );
};

const ServiceBadge = ({ service }) => {
  const label = getServiceLabel(service);
  const styles = {
    Razorpay: { backgroundColor: '#EFF8FF', color: '#026AA7' },
    Digio: { backgroundColor: '#F4F3FF', color: '#5925DC' },
  };
  const style = styles[label] || { backgroundColor: '#F3F4F6', color: '#667085' };
  return (
    <span style={{
      padding: '4px 12px',
      borderRadius: '16px',
      fontWeight: '600',
      fontSize: '13px',
      fontFamily: 'Inter-Medium',
      display: 'inline-block',
      ...style,
    }}>
      
      {label}
    </span>
  );
};

const Settlements = () => {
  const [tableData, setTableData] = useState([]);
  const [totalFetchRows, setTotalFetchRows] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [isLoading, setIsLoading] = useState(false);

  const [statusFilter, setStatusFilter] = useState('');
  const [serviceFilter, setServiceFilter] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [triggerSearch, setTriggerSearch] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [verifyDate, setVerifyDate] = useState('');
  const [isVerifyLoading, setIsVerifyLoading] = useState(false);
  const [exportingSettlementId, setExportingSettlementId] = useState(null);
  const user = null;

  const buildQueryParams = () => {
    const params = {};
    if (rowsPerPage) params.perPage = rowsPerPage;
    if (currentPage) params.page = currentPage;
    if (statusFilter !== '') params.status = statusFilter;
    if (serviceFilter !== '') params.service = serviceFilter;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    return params;
  };

  useEffect(() => {
    setIsLoading(true);
    const params = buildQueryParams();
    axiosInstance
      .get('/settlements', {
        params,
      })
      .then((res) => {
        const data = res?.data?.data;
        setTableData(data?.details || data?.data || data || []);
        const pagination = data?.pagination || data?.meta;
        if (pagination) {
          setTotalFetchRows(pagination.totalRows || pagination.total || 0);
          setCurrentPage(pagination.currentPage || pagination.page || 1);
          setRowsPerPage(pagination.perPage || pagination.limit || rowsPerPage);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        alert(error?.response?.data?.message || 'Error loading settlements');
        setIsLoading(false);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, rowsPerPage, triggerSearch]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const openVerifyModal = (item) => {
    setSelectedItem(item);
    setVerifyDate('');
    setModalOpen(true);
  };

  const closeVerifyModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
    setVerifyDate('');
  };

  const handleVerify = () => {
    if (!verifyDate) {
      alert('Please select a date before verifying.');
      return;
    }
    setIsVerifyLoading(true);
    axiosInstance
      .post(
        '/settlements/verify',
        { settlementId: selectedItem.settlementId || selectedItem.id, verifiedDate: verifyDate, status: SettlementStatus.VERIFIED },
      )
      .then(() => {
        alert('Settlement verified successfully');
        closeVerifyModal();
        setTriggerSearch((prev) => !prev);
      })
      .catch((err) => {
        alert(err?.response?.data?.message || 'Verification failed');
      })
      .finally(() => setIsVerifyLoading(false));
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };




  
  const handleExportTransactions = async (item) => {
    const settlementId = item?.settlementId;
    setExportingSettlementId(settlementId);

    try {
      const isDigio =Number(item?.serviceProvider || item?.service) === ServiceProvider.DIGIO || settlementId?.startsWith('C');

      if (isDigio) {
        await axiosInstance.get('/settlements/digio-transactions', {
          params: { settlementId, exportExcel: true },
        });
      } else {
        await axiosInstance.get('/settlements/razorpay-transactions', {
          params: {
            settlementId,
            date: moment(item?.processedDate).format('YYYY-MM-DD'),
            exportExcel: true,
          },
        });
      }

      alert('Excel will be sent to your email');
    } catch (error) {
      alert(error?.response?.data?.message || 'Unable to export transactions');
    } finally {
      setExportingSettlementId(null);
    }
  };

  const formatAmount = (value = 0) => {
    if (!value && value !== 0) return '-';
    return `₹${Number(value).toLocaleString('en-IN')}`;
  };

  return (
    <div style={{ width: '100%', backgroundColor: 'white', minHeight: '100vh' }}>

        <h1 style={{ fontFamily: 'Inter-Medium', fontSize: '25px', fontWeight: '500', margin: 0, marginTop: '10px', color: '#101828' }}>
          Settlements
        </h1>

        {/* Filters */}
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
          {/* Date From */}
          <Datetime
            key={`dateFrom-${dateFrom}`}
            closeOnSelect={true}
            dateFormat="DD MMM YYYY"
            timeFormat={false}
            value={dateFrom ? new Date(dateFrom) : null}
            onChange={(event) => {
              if (event && event.format) {
                setDateFrom(event.startOf('day').format('YYYY-MM-DD'));
              } else {
                setDateFrom('');
              }
            }}
            locale="en-gb"
            inputProps={{
              placeholder: 'Date From',
              style: {
                fontFamily: 'Inter-Medium',
                backgroundImage: `url(${calender})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '8px center',
                backgroundSize: '16px 16px',
                paddingLeft: '35px',
                fontSize: '14px',
                height: '36px',
                width: '140px',
                border: '1px solid #D0D5DD',
                borderRadius: '8px',
              },
            }}
          />

          {/* Date To */}
          <Datetime
            key={`dateTo-${dateFrom}`}
            closeOnSelect={true}
            dateFormat="DD MMM YYYY"
            timeFormat={false}
            value={dateTo ? new Date(dateTo) : null}
            initialViewDate={dateFrom ? moment(dateFrom, 'YYYY-MM-DD') : moment()}
            onChange={(event) => {
              if (event && event.format) {
                setDateTo(event.hour(23).minute(59).second(59).millisecond(999).format('YYYY-MM-DD'));
              } else {
                setDateTo('');
              }
            }}
            locale="en-gb"
            inputProps={{
              placeholder: 'Date To',
              style: {
                fontFamily: 'Inter-Medium',
                backgroundImage: `url(${calender})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '8px center',
                backgroundSize: '16px 16px',
                paddingLeft: '35px',
                fontSize: '14px',
                height: '36px',
                width: '140px',
                border: '1px solid #D0D5DD',
                borderRadius: '8px',
              },
            }}
          />

          {/* Status filter */}
          <div style={{ minWidth: '160px' }}>
            <Input
              type="select"
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value === '' ? '' : Number(e.target.value));
                setCurrentPage(1);
              }}
              style={{
                color: statusFilter !== '' ? '#101828' : '#667085',
                fontSize: '14px',
                fontFamily: 'Inter-Medium',
                height: '36px',
                width: '100%',
                border: '1px solid #D0D5DD',
                borderRadius: '8px',
                padding: '0 12px',
                backgroundColor: 'white',
              }}
            >
              <option value="" disabled>Status</option>
              <option value="1">Processed</option>
              <option value="2">Verified</option>
            </Input>
          </div>

          {/* Service provider filter */}
          <div style={{ minWidth: '160px' }}>
            <Input
              type="select"
              value={serviceFilter}
              onChange={(e) => {
                setServiceFilter(e.target.value === '' ? '' : Number(e.target.value));
                setCurrentPage(1);
              }}
              style={{
                color: serviceFilter !== '' ? '#101828' : '#667085',
                fontSize: '14px',
                fontFamily: 'Inter-Medium',
                height: '36px',
                width: '100%',
                border: '1px solid #D0D5DD',
                borderRadius: '8px',
                padding: '0 12px',
                backgroundColor: 'white',
              }}
            >
              <option value="" disabled>Service Provider</option>
              <option value="1">Razorpay</option>
              <option value="2">Digio</option>
            </Input>
          </div>

          {/* Search button */}
          <button
            onClick={() => {
              setCurrentPage(1);
              setTriggerSearch((prev) => !prev);
            }}
            style={{
              height: '36px',
              padding: '0 12px',
              backgroundColor: '#D22129',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontFamily: 'Inter-Medium',
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Search
          </button>

          {/* Reset button */}
          <button
            onClick={() => {
              setStatusFilter('');
              setServiceFilter('');
              setDateFrom('');
              setDateTo('');
              setCurrentPage(1);
              setTriggerSearch((prev) => !prev);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '36px',
              padding: '0 12px',
              backgroundColor: '#D22129',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              cursor: 'pointer',
            }}
          >
            <RefreshIcon />
          </button>
        </div>

        {/* Table */}
        {isLoading ? (
          <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%' }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {Array.isArray(tableData) && (
              <div className="tables" style={{ marginTop: '16px' }}>
                <table style={{ width: '100%', tableLayout: 'fixed' }}>
                  <thead className="table-heading">
                    <tr>
                      <th style={{ width: '15%', textAlign: 'left', paddingLeft: '20px', borderTopLeftRadius: '8px' }}>
                        <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Settlement ID</span>
                      </th>
                      <th style={{ width: '10%', textAlign: 'left', paddingLeft: '20px' }}>
                        <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Amount</span>
                      </th>
                      <th style={{ width: '13%', textAlign: 'left', paddingLeft: '20px' }}>
                        <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Processed Date</span>
                      </th>
                      <th style={{ width: '18%', textAlign: 'left', paddingLeft: '20px' }}>
                        <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>UTR</span>
                      </th>
                      <th style={{ width: '13%', textAlign: 'left', paddingLeft: '20px' }}>
                        <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Status</span>
                      </th>
                      <th style={{ width: '16%', textAlign: 'left', paddingLeft: '20px' }}>
                        <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Service Provider</span>
                      </th>
                      <th style={{ width: '13%', textAlign: 'left', paddingLeft: '20px' }}>
                        <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Verified Date</span>
                      </th>
                      <th style={{ width: '7%', textAlign: 'center', paddingLeft: '20px', borderTopRightRadius: '8px' }}>
                        <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Actions</span>
                      </th>
                    </tr>
                  </thead>
                  {tableData.map((item, index) => (
                    <tbody className="table-body" key={item.id || index}>
                      <tr className="table-row" style={{ lineHeight: '14px' }}>
                        <td style={{ paddingLeft: '20px' }}>
                          <span 
                            style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                            {item.settlementId || '-'}
                          </span>
                        </td>
                        <td style={{ paddingLeft: '20px' }}>
                          <span 
                          style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                            {formatAmount(item.amount)}
                          </span>
                        </td>
                        <td style={{ paddingLeft: '20px' }}>
                          <span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                            {formatDate(item.processedDate)}
                          </span>
                        </td>
                        <td style={{ paddingLeft: '20px', maxWidth: '18%' }}>
                          <span style={{
                            fontFamily: 'Inter',
                            fontSize: '14px',
                            color: '#667085',
                            fontWeight: '500',
                            display: 'block',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}>
                            {item.utr || '-'}
                          </span>
                        </td>
                        <td style={{ paddingLeft: '20px' }}>
                          <StatusBadge status={item.status} />
                        </td>
                        <td style={{ paddingLeft: '20px' }}>
                          <ServiceBadge service={item.serviceProvider || item.service} />
                        </td>
                        <td style={{ paddingLeft: '20px' }}>
                          <span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                            {formatDate(item.verifiedDate)}
                          </span>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '10px'
                            }}
                          >
                          <span
                            title="Verify Settlement"
                            onClick={() => openVerifyModal(item)}
                            style={{ cursor: 'pointer' }}
                          >
                            <img src={edit} alt="verify" style={{ width: '14px', height: '14px' }} />
                          </span>
                            <span
                              title="Download Transactions"
                              onClick={() => {
                                if (!exportingSettlementId) handleExportTransactions(item);
                              }}
                              style={{
                                cursor: exportingSettlementId ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                opacity: exportingSettlementId ? 0.6 : 1,

                              }}
                            >
                              {exportingSettlementId === item.settlementId ? (
                                <CircularProgress size={20} />
                              ) : (
                                <DownloadIcon
                                  sx={{
                                    color: '#D22129',
                                    fontSize: '20px',
                                    transition: '0.2s',
                                    '&:hover': {
                                      transform: 'scale(1.15)',
                                    },
                                  }}
                                />
                              )}
                            </span>
                          </div>
                        </td>
                      </tr>
                     
                    </tbody>
                  ))}
                </table>
              </div>
            )}

            {/* Pagination controls */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '20px',
              flexWrap: 'wrap',
              gap: '10px',
              fontFamily: 'Inter',
            }}>
              <div style={{ fontWeight: 'bold', fontSize: '14px', whiteSpace: 'nowrap', color: '#344054' }}>
                {totalFetchRows > 0 ? (
                  <>
                    Showing {(currentPage - 1) * rowsPerPage + 1}-
                    {Math.min(currentPage * rowsPerPage, totalFetchRows)} records of {totalFetchRows} |
                  </>
                ) : (
                  'No Records'
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px', whiteSpace: 'nowrap' }}>
                <span style={{ fontWeight: '600', color: '#344054' }}>Rows Per Pages :</span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  {[15, 50, 100, 500].map((size) => (
                    <span
                      key={size}
                      onClick={() => { setRowsPerPage(size); setCurrentPage(1); }}
                      style={{
                        cursor: 'pointer',
                        padding: '4px 8px',
                        fontSize: '14px',
                        fontWeight: rowsPerPage === size ? '600' : '500',
                        color: rowsPerPage === size ? '#D22129' : '#344054',
                        backgroundColor: rowsPerPage === size ? '#FFF2F3' : 'transparent',
                        borderRadius: '8px',
                        transition: 'all 0.2s',
                      }}
                    >
                      {size}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <PaginationTable
              startPage={currentPage}
              rowsPerPage={rowsPerPage}
              totalRows={totalFetchRows}
              paginate={paginate}
              searchText=""
            />
          </>
        )}

      {/* Verify Modal */}
      <Modal
        open={modalOpen}
        onClose={closeVerifyModal}
        aria-labelledby="verify-settlement-modal"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 420 },
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 4,
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <h3 style={{ margin: 0, fontFamily: 'Inter-Medium', color: '#101828', fontSize: '20px' }}>
              Verify Settlement
            </h3>
            <IconButton onClick={closeVerifyModal} sx={{ color: '#667085' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <hr style={{ border: '1px solid #E4E7EC', margin: '12px 0' }} />

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '16px' }}>
            <div>
              <label style={{ fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>Settlement ID</label>
              <Input
                type="text"
                value={selectedItem?.settlementId || selectedItem?.id || '-'}
                disabled
                style={{ height: '40px', fontSize: '14px', backgroundColor: '#f5f5f5', marginTop: '6px', width: '100%' }}
              />
            </div>
            <div>
              <label style={{ fontSize: '14px', color: '#344054', fontFamily: 'Inter-Medium' }}>Verified Date</label>
              <Input
                type="date"
                value={verifyDate}
                onChange={(e) => setVerifyDate(e.target.value)}
                style={{ height: '40px', fontSize: '14px', marginTop: '6px', width: '100%' }}
              />
            </div>
            <button
              onClick={handleVerify}
              disabled={isVerifyLoading}
              style={{
                backgroundColor: '#D22129',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                cursor: isVerifyLoading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontFamily: 'Inter-Medium',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: isVerifyLoading ? 0.7 : 1,
              }}
            >
              {isVerifyLoading ? 'Verifying...' : 'Verify'}
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Settlements;
